angular.module('gym.invoices').controller('InvoiceRefundCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "flash", "FeatureAvailabilityService", "invoice", "currency", function($scope, $rootScope, $modalInstance, $http, flash, FeatureAvailabilityService, invoice, currency) {
  var gym;
  $scope.invoice = invoice;
  $scope.currency = currency;
  $scope.creditVouchersAvailable = FeatureAvailabilityService.isAvailable('credit_vouchers');
  $scope.refund = {
    amount: +invoice.amount
  };
  gym = $rootScope.gym;
  $scope.paymentCategories = [['non_debit_cash', 'Cash adjustment'], ['non_debit_pos', 'POS Sale adjustment'], ['non_debit_other', 'Other adjustment']];
  if (gym.has_payment_provider) {
    $scope.paymentCategories.unshift(['non_debit_autopayments', 'Adjustment for an Autopayment']);
  }
  $scope.refund.non_debit_payment_category = (function() {
    switch (false) {
      case !(gym.has_payment_provider && invoice.sent_date):
        return 'non_debit_autopayments';
      case !invoice.sale_id:
        return 'non_debit_pos';
      case invoice.paid_with !== 'paid_with_cash':
        return 'non_debit_cash';
      case invoice.paid_with !== 'paid_with_pos':
        return 'non_debit_pos';
      case invoice.paid_with !== 'paid_with_other':
        return 'non_debit_other';
      case invoice.paid_with !== 'paid_with_credit':
        return 'non_debit_credit';
    }
  })();
  $scope.submit = function() {
    var params, path;
    $scope.isLoading = true;
    $scope.error = '';
    path = `gyms/${gym.id}/non_debit_payments`;
    params = {
      contact_id: invoice.contact_id,
      non_debit_payment: {
        amount: $scope.refund.amount * -1,
        membership_id: invoice.membership_id,
        due_date: gym.today,
        description: $scope.refund.description,
        non_debit_payment_related_invoice_number: invoice.invoice_number_base,
        non_debit_payment_category: $scope.refund.non_debit_payment_category
      }
    };
    return $http.post(path, params).then(function(data) {
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error;
      return $scope.isLoading = false;
    });
  };
  $scope.isAmountValid = function() {
    return $scope.refund.amount > 0;
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
